"use strict";
// @ts-ignore
try {
    self['workbox:strategies:6.0.2'] && _();
}
catch (e) { }
